'use strict';

import { EventEmitter } from '../../js/util/eventemitter';

class Widget extends EventEmitter {
  _element: any;

  constructor(element: any) {
    super();

    if (element.length !== 1) {
      throw new Error('Widget wrapping a jQuery object with .length !== 1');
    }

    this._element = element;
    this._element[0].__widget = this;
  }

  show() {
    this._element.show();
  }

  toggle() {
    this._element.toggle();
  }

  hide() {
    this._element.hide();
  }

  parent(className: any) {
    for (let parent = this._element.parent(); parent.length; parent = parent.parent()) {
      if (parent[0].__widget) {
        if (className) {
          if (parent.hasClass(className)) {
            return parent[0].__widget;
          }
        } else {
          return parent[0].__widget;
        }
      }
    }

    return null;
  }

  append(widget: any) {
    if (widget instanceof Widget) {
      this._element.append(widget._element);
    } else {
      throw new Error('Tried to append non-widget to widget');
    }
  }
}

ui.Widget = Widget;
(global as any).Widget = Widget;
